// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.baloa-play-clips-modal .modal2__container {
    width: 622px;
}

.baloa-play-clips-modal__container {
    padding: 18px 28px 24px 28px;
}

.baloa-play-clips-modal__container .baloa-names {
    color: var(--primary-very-dark-color);
    font-weight: var(--font-regular);
    margin-top: 10px;
}

.baloa-play-clips-modal__clips-container {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 8px;
    margin-top: 10px;
    height: 630px;
}

.baloa-play-clips-modal__clips__clip {
    height: 310px;
    border-radius: 8px;
    position: relative;
    cursor: pointer;
}

.baloa-play-clips-modal__clips__clip img {
    width: 100%;
    height: 100%;
    border-radius: 8px;
    object-fit: cover;
}

.baloa-play-clips-modal__clips__clip .baloa-table-column {
    color: var(--white-color);
    position: absolute;
    left: 5px;
    bottom: 5px;
}

.baloa-play-clips-modal__clips-support {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-top: 10px;
    color: var(--primary-very-dark-color);
    cursor: pointer;
}

.baloa-play-clips-modal__clips-support .icon-chevron-roght {
    font-size: 24px;
    margin-left: auto;
}

.baloa-play-clips-modal__clips-support img {
    margin-right: 8px;
}

.baloa-play-clips-modal__clips-payment-message {
    background: var(--new-informative-banner-bg-color);
    padding: 8px;
    border-radius: 4px;
    margin-top: 14px;
}

.baloa-play-clips-modal__clips-payment__title {
    display: flex;
    align-items: center;
    justify-content: flex-start;
}

.baloa-play-clips-modal__clips-payment__title .hubicon-play_arrow {
    font-size: 20px;
    margin-right: 4px;
    color: var(--new-green-color);
}

.baloa-play-clips-modal__clips-payment__title .baloa-normal-medium {
    color: var(--primary-very-dark-color);
    line-height: unset;
}

.baloa-play-clips-modal__clips-payment-message .baloa-names {
    color: var(--primary-very-dark-color);
    margin-top: 8px;
    font-weight: var(--font-regular);
}

.baloa-play-clips-modal__clips-payment-message .button {
    margin-top: 8px;
    width: 100%;
    font-size: 16px;
    padding: 10px 12px;
}

.baloa-play-clips-modal__container .hubicon-add_option {
    font-size: 24px;
}

.baloa-play-clips-modal__container .button .icon {
    grid-area: icon;
}

.baloa-play-clips-modal__container .button.small {
    padding: 8px 12px;
    margin-left: auto;
    margin-right: auto;
    margin-top: 8px;
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */ 

    .baloa-play-clips-modal .modal2__container {
        width: 100%;
        margin: 0;
        border-radius: 0;
        max-height: unset;
        height: 100%;
        background: var(--new-gray-background-color);
    }

    .baloa-play-clips-modal .baloa-play-match-videos__clips-title .hubicon-video_library {
        display: none;
    }

    .baloa-play-clips-modal__container {
        padding: 0;
        height: 100%;
    }

    .baloa-play-clips-modal__container .baloa-names {
        padding: 10px;
        margin-top: 0;
    }

    .baloa-play-clips-modal__clips-container {
        background: var(--new-gray-background-color);
        padding: 10px;
        margin-top: 0;
    }

    .baloa-play-clips-modal__clips-support {
        padding: 10px;
    }

    .baloa-play-clips-modal__clips__clip {
        height: 191px;
    }

    .baloa-play-clips-modal__mobile-support {
        position: fixed;
        bottom: 0;
        background: var(--white-color);
    }

    .baloa-play-clips-modal__clips-payment-message {
        margin: 10px;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/baloa-play/components/baloa-play-clips-modal-component/BaloaPlayClipsModalComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,YAAY;AAChB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,qCAAqC;IACrC,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,QAAQ;IACR,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,SAAS;IACT,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,gBAAgB;IAChB,qCAAqC;IACrC,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kDAAkD;IAClD,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;IACI,qCAAqC;IACrC,kBAAkB;AACtB;;AAEA;IACI,qCAAqC;IACrC,eAAe;IACf,gCAAgC;AACpC;;AAEA;IACI,eAAe;IACf,WAAW;IACX,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;AACnB;;AAEA,yCAAyC,4BAA4B;;IAEjE;QACI,WAAW;QACX,SAAS;QACT,gBAAgB;QAChB,iBAAiB;QACjB,YAAY;QACZ,4CAA4C;IAChD;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,UAAU;QACV,YAAY;IAChB;;IAEA;QACI,aAAa;QACb,aAAa;IACjB;;IAEA;QACI,4CAA4C;QAC5C,aAAa;QACb,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;QACf,SAAS;QACT,8BAA8B;IAClC;;IAEA;QACI,YAAY;IAChB;AACJ","sourcesContent":[".baloa-play-clips-modal .modal2__container {\n    width: 622px;\n}\n\n.baloa-play-clips-modal__container {\n    padding: 18px 28px 24px 28px;\n}\n\n.baloa-play-clips-modal__container .baloa-names {\n    color: var(--primary-very-dark-color);\n    font-weight: var(--font-regular);\n    margin-top: 10px;\n}\n\n.baloa-play-clips-modal__clips-container {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 8px;\n    margin-top: 10px;\n    height: 630px;\n}\n\n.baloa-play-clips-modal__clips__clip {\n    height: 310px;\n    border-radius: 8px;\n    position: relative;\n    cursor: pointer;\n}\n\n.baloa-play-clips-modal__clips__clip img {\n    width: 100%;\n    height: 100%;\n    border-radius: 8px;\n    object-fit: cover;\n}\n\n.baloa-play-clips-modal__clips__clip .baloa-table-column {\n    color: var(--white-color);\n    position: absolute;\n    left: 5px;\n    bottom: 5px;\n}\n\n.baloa-play-clips-modal__clips-support {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    margin-top: 10px;\n    color: var(--primary-very-dark-color);\n    cursor: pointer;\n}\n\n.baloa-play-clips-modal__clips-support .icon-chevron-roght {\n    font-size: 24px;\n    margin-left: auto;\n}\n\n.baloa-play-clips-modal__clips-support img {\n    margin-right: 8px;\n}\n\n.baloa-play-clips-modal__clips-payment-message {\n    background: var(--new-informative-banner-bg-color);\n    padding: 8px;\n    border-radius: 4px;\n    margin-top: 14px;\n}\n\n.baloa-play-clips-modal__clips-payment__title {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n}\n\n.baloa-play-clips-modal__clips-payment__title .hubicon-play_arrow {\n    font-size: 20px;\n    margin-right: 4px;\n    color: var(--new-green-color);\n}\n\n.baloa-play-clips-modal__clips-payment__title .baloa-normal-medium {\n    color: var(--primary-very-dark-color);\n    line-height: unset;\n}\n\n.baloa-play-clips-modal__clips-payment-message .baloa-names {\n    color: var(--primary-very-dark-color);\n    margin-top: 8px;\n    font-weight: var(--font-regular);\n}\n\n.baloa-play-clips-modal__clips-payment-message .button {\n    margin-top: 8px;\n    width: 100%;\n    font-size: 16px;\n    padding: 10px 12px;\n}\n\n.baloa-play-clips-modal__container .hubicon-add_option {\n    font-size: 24px;\n}\n\n.baloa-play-clips-modal__container .button .icon {\n    grid-area: icon;\n}\n\n.baloa-play-clips-modal__container .button.small {\n    padding: 8px 12px;\n    margin-left: auto;\n    margin-right: auto;\n    margin-top: 8px;\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */ \n\n    .baloa-play-clips-modal .modal2__container {\n        width: 100%;\n        margin: 0;\n        border-radius: 0;\n        max-height: unset;\n        height: 100%;\n        background: var(--new-gray-background-color);\n    }\n\n    .baloa-play-clips-modal .baloa-play-match-videos__clips-title .hubicon-video_library {\n        display: none;\n    }\n\n    .baloa-play-clips-modal__container {\n        padding: 0;\n        height: 100%;\n    }\n\n    .baloa-play-clips-modal__container .baloa-names {\n        padding: 10px;\n        margin-top: 0;\n    }\n\n    .baloa-play-clips-modal__clips-container {\n        background: var(--new-gray-background-color);\n        padding: 10px;\n        margin-top: 0;\n    }\n\n    .baloa-play-clips-modal__clips-support {\n        padding: 10px;\n    }\n\n    .baloa-play-clips-modal__clips__clip {\n        height: 191px;\n    }\n\n    .baloa-play-clips-modal__mobile-support {\n        position: fixed;\n        bottom: 0;\n        background: var(--white-color);\n    }\n\n    .baloa-play-clips-modal__clips-payment-message {\n        margin: 10px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
